import React from 'react';
import "./CollapsibleList.css";

class CollapsibleList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {openStatus:true}
    }

    togglePanel = (e) => {
        this.setState({
            openStatus: !this.state.openStatus
        })
    }

    render() {
        return (
            <div className="ListHeader">
            <div onClick={e => this.togglePanel(e)} className={this.state.openStatus ? 'multiple-items-hide' : 'multiple-items'}> Multiple items</div>
            {
                    this.state.openStatus ? null : <ul className="unorderListGroup">
                        {this.props.items.map((item,index)=><li key={index}>{item}</li>)}
                        </ul>}
            </div>
            )
    }
            }

export default CollapsibleList